module.exports = __webpack_public_path__ + "img/icon-modernise-platforn.98f3fe90.svg";